/**
 * Order type.
 *
 * The available types come from configuration, not from a hardcoded union
 * (FR-010). A different business enables different ones, and their labels come
 * from BrandConfig.copy — so a shop that says "For here" instead of "Dine in"
 * changes a config value, not a component.
 */

interface OrderTypeProps {
  types: string[];
  labels: Record<string, string>;
  value: string;
  onChange(next: string): void;
}

export function OrderType({ types, labels, value, onChange }: OrderTypeProps) {
  if (types.length <= 1) return null;

  return (
    <div className="ordertype" role="group" aria-label="Order type">
      {types.map((type) => (
        <button
          key={type}
          type="button"
          className={`ordertype__option${type === value ? " is-selected" : ""}`}
          onClick={() => onChange(type)}
          aria-pressed={type === value}
        >
          {labels[type] ?? type}
        </button>
      ))}
    </div>
  );
}

export default OrderType;
